import { makeVariant } from '../../../types/makeVariant'
import { getBrandZIndex } from '../../zIndex'

export const layout = makeVariant({
  container: {
    flex: '1 1 auto',
    display: 'flex',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  absolute: {
    variant: 'layout.container',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
  },
  base: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    position: 'relative',
  },
  appHeaderDownload: {
    height: 80,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    borderBottom: ['1px solid', 'none', 'none'],
    borderBottomColor: ['border', 'transparent', 'transparent'],
    justifyContent: 'space-between',
    px: [4, 4, 7],
    zIndex: getBrandZIndex('languageSelector'),
  },
  downloadSection: {
    backgroundColor: '#fbfbfb',
    textAlign: 'center',
    py: '100px',
    px: '2',
  },
  jottaAppFooterContainer: {
    borderTop: '1px solid #eaeaea',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'nowrap',
    color: 'black',
    padding: '56px',
  },
  center: {
    variant: 'layout.container',
    justifyContent: 'center',
    alignItems: 'center',
  },
  appTopToolbar: {
    height: '64px',
    display: 'flex',
    flex: '1 1 auto',
    zIndex: getBrandZIndex('appMainTopToolbar'),
    backgroundColor: 'background',
    whiteSpace: 'nowrap',
    fontSize: 2,
    justifyContent: 'flex-start',
    mx: 3,
    px: 2,
    boxShadow: '0 4px 5px -5px rgb(0 0 0 / 30%)',
    borderBottom: '1px solid var(--color-border)',
    transition: 'opacity 300ms, width 300ms',
    '&:empty': {
      display: 'none',
    },
  },
  downloadSectionContainer1: {
    backgroundColor: 'background',
    textAlign: 'center',
    py: '100px',
    px: '2',
  },
  downloadSectionContainer2: {
    display: 'flex',
    justifyContent: 'center',
  },
  downloadPageContainer: {
    backgroundColor: 'white',
    flexGrow: 1,
  },
  downloadPageWrapper: {
    textAlign: 'center',
    mt: ['108px', '80px', '80px'],
    mb: '74px',
    px: 2,
  },
  modalBackground: {
    variant: 'layout.absolute',
    backgroundColor: 'modalBackground',
    backdropFilter: ['none', 'blur(10px)'],
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: getBrandZIndex('modal'),
    overflow: 'hidden',
  },
  modalBackgroundLight: {
    variant: 'layout.modalBackground',
    backgroundColor: 'rgb(var(--rgb-background) / 0.9)',
  },
  modalBackgroundLightFixed: {
    variant: 'layout.modalBackgroundLight',
    position: 'fixed',
  },
  modalBackgroundPrimary: {
    variant: 'layout.modalBackground',
    position: 'fixed',
    backgroundColor: 'rgb(var(--rgb-primary) / 0.9)',
  },
  settingsContainer: {
    gap: 4,
    py: 5,
    px: [2, '24px', '24px'],
  },
  mediaItemBackground: {
    content: '""',
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    background:
      'linear-gradient(black -100px, transparent 70px, transparent calc(100% - 70px), transparent calc(100% + 100px))',
  },
  smartPhotoBannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'relative',
    width: '100%',
    maxWidth: '550px',
    borderRadius: '12px',
    padding: [3, 4],
    bg: 'white',
    border: '1px solid',
    borderColor: 'primary',
    mt: 3,
  },
})
